import { render, staticRenderFns } from "./printHistoriaAdulto.vue?vue&type=template&id=4f322551&scoped=true"
import script from "./printHistoriaAdulto.vue?vue&type=script&lang=js"
export * from "./printHistoriaAdulto.vue?vue&type=script&lang=js"
import style0 from "./printHistoriaAdulto.vue?vue&type=style&index=0&id=4f322551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f322551",
  null
  
)

export default component.exports